"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactVirtualized = require("react-virtualized");

var _utils = require("@alycecom/utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _ramda = require("ramda");

var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));

var _Buttons = require("../Buttons");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      zIndex = _ref.zIndex;
  return {
    autocompleteRoot: {
      margin: spacing(2)
    },
    popper: {
      zIndex: zIndex.modal,
      border: "1px solid ".concat(palette.primary.main),
      borderRadius: 5,
      minWidth: 280,
      maxWidth: 320,
      width: 'auto',
      backgroundColor: palette.common.white,
      marginTop: "".concat(spacing(1.5), " !important"),
      marginBottom: "".concat(spacing(1.5), " !important")
    },
    popperDisablePortal: {
      position: 'relative',
      border: 'none',
      padding: 0
    },
    paper: {
      width: '100%',
      boxShadow: 'none',
      margin: 0,
      borderTop: "2px solid ".concat(palette.grey.dark)
    },
    searchIcon: {
      color: palette.grey.dark
    },
    inputAutocomplete: {
      padding: '5px !important'
    },
    checkbox: {
      color: palette.primary.main,
      marginRight: spacing(1)
    },
    lockIcon: {
      width: 42,
      height: 42,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: spacing(1)
    },
    disabled: {
      '&:disabled': {
        border: "1px solid ".concat(palette.grey.main)
      }
    },
    virtualizedList: {
      '&:focus': {
        outline: 'none'
      }
    },
    listbox: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: 0
    },
    buttonWrapper: {
      width: '100%',
      position: 'relative'
    },
    valueLabel: {
      display: 'inline-block',
      maxWidth: 'calc(100% - 25px)'
    },
    optionLabel: {
      overflowX: 'hidden',
      textOverflow: 'ellipsis'
    },
    externalLabel: {
      color: palette.text.primary,
      padding: spacing(0, 0.5),
      fontSize: 16,
      fontWeight: 400,
      lineHeight: 1,
      paddingLeft: spacing(1),
      position: 'absolute',
      top: -6,
      left: 10,
      zIndex: 1,
      backgroundColor: palette.common.white,
      transform: 'scale(0.75)'
    },
    optionItem: {
      '&:hover': {
        backgroundColor: '#0000000a'
      }
    }
  };
});
var DEFAULT_OPTION_HEIGHT = 54;
var VirtualizedListBox = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
      _props$rowHeight = props.rowHeight,
      _rowHeight = _props$rowHeight === void 0 ? DEFAULT_OPTION_HEIGHT : _props$rowHeight,
      _props$maxVisibleRows = props.maxVisibleRows,
      maxVisibleRows = _props$maxVisibleRows === void 0 ? 7 : _props$maxVisibleRows,
      rootProps = (0, _objectWithoutProperties2["default"])(props, ["children", "rowHeight", "maxVisibleRows"]);

  var classes = useStyles();

  var items = _react["default"].Children.toArray(children);

  var rowCount = items.length;
  var maxHeight = maxVisibleRows * _rowHeight;
  var height = (0, _react.useMemo)(function () {
    return rowCount < maxVisibleRows ? items.reduce(function (acc, item) {
      return acc + (item.props['data-height'] || _rowHeight);
    }, 0) : maxHeight;
  }, [items, maxHeight, rowCount, _rowHeight, maxVisibleRows]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rootProps, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, {
    disableHeight: true
  }, function (_ref2) {
    var width = _ref2.width;
    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.List, {
      className: classes.virtualizedList,
      rowCount: rowCount,
      rowHeight: function rowHeight(_ref3) {
        var index = _ref3.index;
        return items[index].props['data-height'] || _rowHeight;
      },
      width: width,
      height: height,
      rowRenderer: function rowRenderer(_ref4) {
        var key = _ref4.key,
            index = _ref4.index,
            style = _ref4.style;
        return /*#__PURE__*/_react["default"].cloneElement(items[index], {
          key: key,
          style: style
        });
      }
    });
  }));
});

var MultiAutocomplete = function MultiAutocomplete(_ref5) {
  var label = _ref5.label,
      searchLabel = _ref5.searchLabel,
      _ref5$isLabelExternal = _ref5.isLabelExternal,
      isLabelExternal = _ref5$isLabelExternal === void 0 ? false : _ref5$isLabelExternal,
      name = _ref5.name,
      _ref5$disabled = _ref5.disabled,
      disabled = _ref5$disabled === void 0 ? false : _ref5$disabled,
      _ref5$classes = _ref5.classes,
      extraClasses = _ref5$classes === void 0 ? {} : _ref5$classes,
      value = _ref5.value,
      _onChange = _ref5.onChange,
      options = _ref5.options,
      getOptionLabel = _ref5.getOptionLabel,
      _ref5$getOptionLocked = _ref5.getOptionLocked,
      getOptionLocked = _ref5$getOptionLocked === void 0 ? function () {
    return false;
  } : _ref5$getOptionLocked,
      _ref5$loading = _ref5.loading,
      loading = _ref5$loading === void 0 ? false : _ref5$loading,
      _ref5$multiple = _ref5.multiple,
      multiple = _ref5$multiple === void 0 ? true : _ref5$multiple,
      getOptionSelected = _ref5.getOptionSelected,
      getOptionKey = _ref5.getOptionKey,
      groupBy = _ref5.groupBy,
      renderGroup = _ref5.renderGroup,
      renderOption = _ref5.renderOption,
      onClose = _ref5.onClose,
      onOpen = _ref5.onOpen,
      listboxProps = _ref5.listboxProps,
      buttonIconProps = _ref5.buttonIconProps,
      _ref5$renderValue = _ref5.renderValue,
      renderValue = _ref5$renderValue === void 0 ? function (val) {
    if (multiple) {
      var _val$length;

      var selectedCount = Array.isArray(val) && ((_val$length = val === null || val === void 0 ? void 0 : val.length) !== null && _val$length !== void 0 ? _val$length : 0);
      return selectedCount > 0 ? "".concat(label, " (").concat(selectedCount, ")") : label;
    }

    return getOptionLabel(val);
  } : _ref5$renderValue,
      PopperProps = _ref5.PopperProps,
      _ref5$selectAllEnable = _ref5.selectAllEnabled,
      selectAllEnabled = _ref5$selectAllEnable === void 0 ? true : _ref5$selectAllEnable;
  var classes = useStyles();

  var _useTheme = (0, _material.useTheme)(),
      palette = _useTheme.palette;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var isOpen = !!anchorEl;
  var id = isOpen ? "AlyceUI.MultiSelect.".concat(name) : undefined;
  var handleOpen = (0, _react.useCallback)(function (event) {
    setAnchorEl(event.currentTarget);
    onOpen && onOpen();
  }, [onOpen]);
  var handleClose = (0, _react.useCallback)(function (event, reason) {
    if (reason === 'toggleInput') {
      return;
    }

    if (anchorEl) {
      anchorEl.focus();
    }

    setAnchorEl(null);
    setInputValue('');
    onClose && onClose();
  }, [anchorEl, onClose]);
  var handleInputChange = (0, _react.useCallback)(function (event, searchValue, reason) {
    if (reason === 'input') {
      setInputValue(searchValue);
    }
  }, []);

  var defaultRenderOption = function defaultRenderOption(_ref6, option, _ref7) {
    var className = _ref6.className,
        _ = _ref6.onMouseOver,
        props = (0, _objectWithoutProperties2["default"])(_ref6, ["className", "onMouseOver"]);
    var selected = _ref7.selected;
    var isDisabled = getOptionLocked === null || getOptionLocked === void 0 ? void 0 : getOptionLocked(option);
    var optionLabel = getOptionLabel(option);
    return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({}, props, {
      className: (0, _classnames["default"])(className, classes.optionItem)
    }), multiple && /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      className: (0, _classnames["default"])(classes.checkbox, extraClasses === null || extraClasses === void 0 ? void 0 : extraClasses.checkbox),
      checked: selected,
      onChange: function onChange() {},
      color: "primary",
      icon: isDisabled ? /*#__PURE__*/_react["default"].createElement(_material.Box, {
        width: 24,
        height: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "lock",
        color: "grey.main"
      })) : undefined,
      disabled: isDisabled,
      "data-testid": "AlyceUI.MultiSelect.Option.".concat((0, _utils.toUnderscore)(optionLabel))
    }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
      className: classes.optionLabel,
      "data-testid": "AlyceUI.MultiSelect.OptionLabel.".concat((0, _utils.toUnderscore)(optionLabel))
    }, optionLabel));
  };

  var optionRenderer = function optionRenderer(_ref8, option, state) {
    var className = _ref8.className,
        onMouseOver = _ref8.onMouseOver,
        props = (0, _objectWithoutProperties2["default"])(_ref8, ["className", "onMouseOver"]);
    var isDisabled = getOptionLocked === null || getOptionLocked === void 0 ? void 0 : getOptionLocked(option);
    var hasSelectAll = selectAllEnabled && 'data-option-index' in props && props['data-option-index'] === 0 && multiple;
    var isAllSelected = Array.isArray(options) && Array.isArray(value) && options.length === value.length;
    var optionHeight = (listboxProps === null || listboxProps === void 0 ? void 0 : listboxProps.rowHeight) || DEFAULT_OPTION_HEIGHT;
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-height": hasSelectAll ? optionHeight * 2 : optionHeight,
      key: getOptionKey ? getOptionKey(option) : option
    }, hasSelectAll && /*#__PURE__*/_react["default"].createElement("li", {
      role: "option",
      onKeyPress: function onKeyPress() {},
      "aria-selected": isAllSelected,
      className: (0, _classnames["default"])(className, classes.optionItem),
      onClick: function onClick() {
        if (isAllSelected) {
          _onChange([], name);
        } else {
          _onChange(options, name);
        }
      },
      key: "select-all"
    }, multiple && /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      className: (0, _classnames["default"])(classes.checkbox, extraClasses === null || extraClasses === void 0 ? void 0 : extraClasses.checkbox),
      checked: isAllSelected,
      onChange: function onChange() {},
      color: "primary",
      disabled: isDisabled,
      "data-testid": "AlyceUI.MultiSelect.Option.SelectAll"
    }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
      className: classes.optionLabel,
      "data-testid": "AlyceUI.MultiSelect.OptionLabel.SelectAll"
    }, "Select All")), (renderOption || defaultRenderOption)(_objectSpread(_objectSpread({}, props), {}, {
      className: (0, _classnames["default"])(className, classes.optionItem),
      onMouseOver: onMouseOver
    }), option, state));
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: (0, _classnames["default"])(classes.buttonWrapper, extraClasses.buttonWrapper)
  }, isLabelExternal && /*#__PURE__*/_react["default"].createElement(_material.InputLabel, {
    className: classes.externalLabel,
    id: "AlyceUI.MultiAutoComplete.ExternalLabel"
  }, label), /*#__PURE__*/_react["default"].createElement(_Buttons.BaseButton, {
    width: "100%",
    variant: "outlined",
    "aria-describedby": id,
    "data-testid": (0, _utils.toUnderscore)("multi-select-filter-".concat(name)),
    color: palette.grey.main,
    hoverColor: palette.grey.main,
    bgColor: palette.common.white,
    borderColor: palette.grey.regular,
    onClick: handleOpen,
    disabled: disabled,
    overrideClass: classes.disabled
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('Body-Regular-Left-Inactive', classes.valueLabel, extraClasses.valueLabel),
    "data-testid": "multi-select-filter-value"
  }, renderValue === null || renderValue === void 0 ? void 0 : renderValue(value)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    icon: isOpen ? 'chevron-up' : 'chevron-down'
  }, buttonIconProps))))), /*#__PURE__*/_react["default"].createElement(_material.Popper, (0, _extends2["default"])({
    id: id,
    open: isOpen,
    anchorEl: anchorEl,
    placement: "bottom-start",
    className: (0, _classnames["default"])(classes.popper, extraClasses.popper),
    disablePortal: true
  }, PopperProps), /*#__PURE__*/_react["default"].createElement(_material.Autocomplete, {
    classes: {
      root: classes.autocompleteRoot,
      popper: (0, _classnames["default"])(classes.popper, extraClasses.popper),
      popperDisablePortal: classes.popperDisablePortal,
      paper: classes.paper,
      inputRoot: classes.inputAutocomplete,
      listbox: (0, _classnames["default"])(classes.listbox, extraClasses.listbox)
    },
    open: true,
    onClose: handleClose,
    multiple: multiple || undefined,
    disableCloseOnSelect: multiple,
    value: value,
    onChange: function onChange(event, newValue, reason, details) {
      _onChange(newValue, name, reason, details);
    },
    options: options,
    getOptionLabel: getOptionLabel,
    getOptionDisabled: getOptionLocked,
    isOptionEqualToValue: getOptionSelected,
    groupBy: groupBy,
    ListboxComponent: VirtualizedListBox,
    ListboxProps: listboxProps,
    inputValue: inputValue,
    onInputChange: handleInputChange,
    disableListWrap: true,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_material.TextField, (0, _extends2["default"])({}, params, {
        id: "field-search-".concat(name, "-id"),
        name: "search-".concat(name),
        autoFocus: true,
        fullWidth: true,
        variant: "outlined",
        label: searchLabel || "Search ".concat((0, _ramda.toLower)(label)),
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          startAdornment: /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
            position: "start"
          }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
            className: classes.searchIcon
          })),
          endAdornment: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, loading ? /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
            color: "inherit",
            size: 20
          }) : null)
        })
      }));
    },
    renderGroup: renderGroup,
    renderOption: optionRenderer
  })));
};

var _default = MultiAutocomplete;
exports["default"] = _default;